import React from 'react';

import getAuthToken from '../components/modules/get_auth_token';

const CmsSalesmateApp = () => {
  const [message, setMessage] = React.useState('');
  const [error, setError] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  function handleMessageChange(e) {
    setMessage(e.target.value);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const trimmedMessage = message.trim();
    if (!trimmedMessage) {
      setError('Message cannot be blank.');
      setSuccessMessage('');
      return;
    }

    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await fetch(`${window.postbuildEnv.DEFAULT_URL}/cms/salesmate`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': getAuthToken()
        },
        body: JSON.stringify({ salesmate: { message: trimmedMessage } })
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error || 'Failed to submit salesmate form. Please try again.');
      }

      setMessage('');
      setSuccessMessage('Salesmate sync has started.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form acceptCharset="UTF-8" className='cms-salesmate-form' onSubmit={handleSubmit}>
      <div className='cms-form cms-salesmate-form__layout'>
        <div className='cms-meta-middle cms-salesmate-form__content'>
          <div className='cms-form-row cms-salesmate-form__row'>
            <label htmlFor='message' id='message-label'>Input: a comma-separated list of LMS school ids. These schools will be synced to Salesmate.</label>
            <textarea
              aria-labelledby='message-label'
              id='message'
              name='message'
              onChange={handleMessageChange}
              rows={6}
              value={message}
              wrap='soft'
            />
          </div>
          {error && <p className='error-text'>{error}</p>}
          {successMessage && <p>{successMessage}</p>}
          <div className='cms-submit-row cms-salesmate-form__submit-row'>
            <button aria-label={loading ? 'Submitting Salesmate form' : 'Submit Salesmate form'} disabled={loading} type='submit'>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CmsSalesmateApp;
